// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3s5MQ","file":"styles_file__1JwOj"};